import { useState } from 'react';
import { Link } from 'react-router-dom';
import { warehouseexecApi } from '../../api/warehouseexec';

export function MobileWarehousePage() {
  const [barcode, setBarcode] = useState('');
  const [log, setLog] = useState<string[]>([]);

  function scan() {
    if (!barcode.trim()) return;
    setLog((prev) => [`Scanned: ${barcode}`, ...prev].slice(0, 20));
    setBarcode('');
  }

  async function quickPickConfirm() {
    try {
      const tasks = await warehouseexecApi.listPickTasks();
      if (!tasks.length) {
        setLog((prev) => ['No pick tasks available', ...prev]);
        return;
      }
      await warehouseexecApi.confirmPick({
        task_id: tasks[0].id,
        worker_id: 'mobile-1',
        barcode: barcode || 'MOBILE-SCAN',
        items: [{ item_id: 'mobile', picked_qty: 1 }],
      });
      setLog((prev) => [`Pick confirmed for ${tasks[0].id.slice(0, 8)}`, ...prev]);
    } catch (e) {
      setLog((prev) => [String(e), ...prev]);
    }
  }

  return (
    <div className="mx-auto max-w-md p-4">
      <Link to="/warehouse" className="text-sm text-slate-600 hover:underline">← Warehouse hub</Link>
      <h1 className="mt-2 text-xl font-semibold">Mobile warehouse</h1>
      <p className="text-sm text-slate-600">Barcode / QR scanner workflow</p>
      <label className="mt-6 block text-sm font-medium" htmlFor="barcode">Scan barcode</label>
      <input
        id="barcode"
        value={barcode}
        onChange={(e) => setBarcode(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && scan()}
        className="mt-1 w-full rounded-lg border px-3 py-3 text-lg font-mono"
        placeholder="Scan or type…"
        autoComplete="off"
      />
      <div className="mt-3 flex gap-2">
        <button type="button" onClick={scan} className="flex-1 rounded-lg bg-slate-900 py-3 text-sm text-white">Log scan</button>
        <button type="button" onClick={() => void quickPickConfirm()} className="flex-1 rounded-lg border py-3 text-sm">Confirm pick</button>
      </div>
      <ul className="mt-6 space-y-2 text-sm">
        {log.map((line, i) => <li key={i} className="rounded border p-2 font-mono text-xs">{line}</li>)}
      </ul>
    </div>
  );
}
